export default {
    translation: {
        "Головна": 'Головна',
        'струйні нафтові помпи': 'струйні нафтові помпи',
        'Прилад УЄОС-4': 'Прибор УЄОС-4',
        'Прибор УЭОС-4Б': 'Прибор УЄОС-4Б',
        'Прибор УЭОС-4М': 'Прибор УЄОС-4М',
        'Прибор УЭОС-5': 'Прибор УЄОС-5',
        'Прибор УЭОС-5К': 'Прибор УЄОС-5К',
        'Прибор УЭОС-6': 'Прибор УЄОС-6',
        'Прибор УЭОС-7': 'Прибор УЄОС-7',
        'эжекторные приборы': 'ежекторні прилади',
        'Пакеры': 'Пакери',
        'магнитные перехватчики': 'магнітні перехоплювачі'
    }
};
